import { ApiServiceV1 } from '@services/api.service';

export default {
  async getMachines({
    suffix, state = null, name = null,
    pageNum = 1, pageSize = 10,
  }) {
    const { data } = await ApiServiceV1.get(`${suffix}/machine`, {
      params: {
        state, name, pageNum, pageSize,
      },
    });
    return data || [];
  },
  syncMachines({ suffix }) {
    return ApiServiceV1.post(`${suffix}/machine/sync`);
  },
};
